import { Component, EventEmitter, Input, Output } from "@angular/core";
import { NavigationService } from "src/services/navigation/navigation.service";
import { EditingMode, toggleEditMode } from "../../../../shared/editing.const";

export type EditResult = "submitted" | "cancelled";

@Component({
  selector: "rc-page-title",
  templateUrl: "./page-title.component.html",
  styleUrls: ["./page-title.component.scss"],
  standalone: false,
})
export class PageTitleComponent {
  @Input() public color: string = "dark";
  @Input() public isCreateValid: boolean | undefined;
  @Input() public isEditValid: boolean | undefined;
  @Input() public title: string;
  @Input() public size: "small" | "large" = "large";
  @Input() public subtitle: string;
  @Input() public showAdminMenu = false;
  @Input() public showCreateButton = false;
  @Input() public showEditButton = false;
  @Input() public showGoBack = false;
  @Input() public showCustomGoBack = false;
  @Input() public showGoToHome = false;

  @Output() public onCustomGoBack = new EventEmitter<void>();
  @Output() public onEditEnable = new EventEmitter<EditingMode>();
  @Output() public onCreateComplete = new EventEmitter<EditResult>();
  @Output() public onEditComplete = new EventEmitter<EditResult>();

  public editStatus: EditingMode = "read";

  constructor(public readonly navigationService: NavigationService) {}

  public async onClickEdit(): Promise<void> {
    this.editStatus = toggleEditMode(this.editStatus);

    this.onEditEnable.emit();
  }

  public onCreateCompleted(result: EditResult): void {
    this.onCreateComplete.emit(result);
  }

  public onEditCompleted(result: EditResult): void {
    this.editStatus = toggleEditMode(this.editStatus);

    this.onEditComplete.emit(result);
  }
}
